import { type User as Config } from '@autone/openapi-core';
import { createSlice } from '@reduxjs/toolkit';

import { userApi } from './services/';

const initialState = {
  config: { default_price_type: 'rrp', default_currency: 'EUR' } as Config,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    UPDATE_CONFIG: (state, action) => ({
      ...state,
      config: action.payload,
    }),
    UPDATE_PROFILE: (state, action) => ({
      ...state,
      config: {
        ...state.config,
        profile: action.payload.profile,
      },
    }),
    UPDATE_PROFILE_IMAGE: (state, action) => ({
      ...state,
      config: {
        ...state.config,
        user_image_url: action.payload.profileImageUrl,
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      userApi.endpoints.getUserConfig.matchFulfilled,
      (state, { payload }) => ({ ...state, config: payload }),
    );
  },
});

export const { UPDATE_CONFIG, UPDATE_PROFILE, UPDATE_PROFILE_IMAGE } =
  userSlice.actions;

export default userSlice.reducer;
